import { render, staticRenderFns } from "./SlotClosureEditDialog.vue?vue&type=template&id=06a8626d&scoped=true"
import script from "./SlotClosureEditDialog.vue?vue&type=script&lang=js"
export * from "./SlotClosureEditDialog.vue?vue&type=script&lang=js"
import style0 from "./SlotClosureEditDialog.vue?vue&type=style&index=0&id=06a8626d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a8626d",
  null
  
)

export default component.exports